import { pushAnalyticsObjToDataLayer } from "@/utils/helper"
import {
  FAVORITES,
  NAVIGATION,
} from "@/components/MyFavorites/v1/analytics/constant"

export const favNoResultDataLayer = e => {
  const { target: { href = "", textContent = "" } = {} } = e
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const { category: { pageType } = {} } = page
  const text = textContent.toLowerCase()
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${pageType}:${FAVORITES}:${text}`,
    eventName: `${pageType}:${FAVORITES}:${text}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: NAVIGATION,
    internalLinkName: text,
    internalLinkPosition: FAVORITES,
    internalLinkType: `${pageType}:${NAVIGATION}`,
    internalLinkZoneName: `${pageType}:${FAVORITES}`,
    internalLinkURL: href,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
